export const SET_THEME = 'APP/SET_THEME'
export const SHOW_ALERT = 'APP/SHOW_ALERT'
export const SHOW_LOADER = 'APP/SHOW_LOADER'
export const HIDE_LOADER = 'APP/HIDE_LOADER'
export const HIDE_ALERT = 'APP/HIDE_ALERT'
export const TOGGLE_TRUE_LOG_IN = 'APP/TOGGLE_TRUE_LOG_IN'
export const TOGGLE_FALSE_LOG_IN = 'APP/TOGGLE_FALSE_LOG_IN'
export const INVALID_TOKEN = 'APP/INVALID_TOKEN'
export const FETCH_CARS = 'CAR/FETCH_CARS'
export const SET_CAR_PAGINATION_DATA = 'CAR/SET_CAR_PAGINATION_DATA'
export const FETCH_MODEL_BRAND = 'CAR/FETCH_MODEL_BRAND'
export const FETCH_CLIENTS = 'CLIENT/FETCH_CLIENTS'
export const TOGGLE_TRUE_LOGGED_CLIENT = 'CLIENT/TOGGLE_TRUE_LOGGED_CLIENT'
export const TOGGLE_FALSE_LOGGED_CLIENT = 'CLIENT/TOGGLE_FALSE_LOGGED_CLIENT'
export const SET_CLIENT_PAGINATION_DATA = 'CLIENT/SET_CLIENT_PAGINATION_DATA'
export const CREATE_ORDER = 'ORDER/CREATE_ORDER'
export const FETCH_ORDERS = 'ORDER/FETCH_ORDERS'
export const SET_ORDER_ID = 'ORDER/SET_ORDER_ID'
export const SET_ORDER_LINK = 'ORDER/SET_ORDER_LINK'
export const SET_RENT_START_DATE = 'ORDER/SET_RENT_START_DATE'
export const SET_RENT_END_DATE = 'ORDER/SET_RENT_END_DATE'
export const SET_RENT_START_TIME = 'ORDER/SET_RENT_START_TIME'
export const SET_RENT_END_TIME = 'ORDER/SET_RENT_END_TIME'
export const SET_EXTENDED_ORDER = 'ORDER/SET_EXTENDED_ORDER'
export const SET_ORDER_PAGINATION_DATA = 'ORDER/SET_ORDER_PAGINATION_DATA'
export const SET_ORDERS_STATISTICS = 'ANALYTICS/SET_ORDERS_STATISTICS'
export const SET_TOP_CLIENTS = 'ANALYTICS/SET_TOP_CLIENTS'
export const SET_STATISTICS_ALLDAY = 'ANALYTICS/SET_STATISTICS_ALLDAY'
export const FETCH_TG_CLIENTS = 'TELEGRAM/FETCH_TG_CLIENTS'
